var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteTaskEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty state Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 634000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170",
    x: 81,
    y: 48,
    width: 35.9512,
    height: 49.288,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167",
    x: 86.2188,
    y: 77.4299,
    width: 26.0936,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173",
    x: 86.2188,
    y: 84.4299,
    width: 26.0936,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172",
    x: 86,
    y: 67,
    width: 26,
    height: 8,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171",
    x: 86,
    y: 51,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634001"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170_2",
    x: 16,
    y: 48,
    width: 35.9512,
    height: 49.288,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167_2",
    x: 34,
    y: 57,
    width: 14,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172_2",
    x: 20,
    y: 67,
    width: 28,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173_2",
    x: 20,
    y: 73,
    width: 28,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3174",
    x: 20,
    y: 79,
    width: 28,
    height: 8,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171_2",
    x: 20.2188,
    y: 52,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1667 38C90.7117 38.6908 96 43.411 96 60.9488V83.9744C96 99.3248 92.8333 107 77 107H58C42.1667 107 39 99.3248 39 83.9744V60.9488C39 43.4494 44.2883 38.6908 54.8333 38",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1667 38C90.7117 38.6908 96 43.411 96 60.9488V83.9744C96 99.3248 92.8333 107 77 107H58C42.1667 107 39 99.3248 39 83.9744V60.9488C39 43.4494 44.2883 38.6908 54.8333 38",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M79.75 63.4716C75.0325 63.0041 70.2867 62.7633 65.555 62.7633C62.75 62.7633 59.945 62.905 57.14 63.1883L54.25 63.4716",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.0417 62.0408L62.3534 60.1849C62.5801 58.8391 62.7501 57.8333 65.1442 57.8333H68.8559C71.2501 57.8333 71.4342 58.8958 71.6467 60.1991L71.9584 62.0408",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M76.7042 67.948L75.7834 82.2138C75.6276 84.438 75.5001 86.1663 71.5476 86.1663H62.4526C58.5001 86.1663 58.3726 84.438 58.2167 82.2138L57.2959 67.948",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M64.6343 78.375H69.3518",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M63.4583 72.7083H70.5416",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M59.75 45.25H75.25C83 45.25 83 41.375 83 37.5C83 29.75 79.125 29.75 75.25 29.75H59.75C55.875 29.75 52 29.75 52 37.5C52 45.25 55.875 45.25 59.75 45.25Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTaskEmpty);
export default __webpack_public_path__ + "static/media/deleteTaskEmpty.1496272ebced60fbf1196e782383d46c.svg";
export { ForwardRef as ReactComponent };